var _clipPath;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDataOsLogoCommon2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 74 12",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    xmlnsSerif: "http://www.serif.com/",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    id: "Artboard1",
    x: 0,
    y: 0,
    width: 74,
    height: 12,
    style: {
      fill: "none"
    }
  }), _clipPath || (_clipPath = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Artboard11",
    serifId: "Artboard1",
    x: 0,
    y: 0,
    width: 74,
    height: 12
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.113677,0,0,0.113677,-0.977626,-0.943522)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M154.7,10.3L189.1,10.3C219.1,10.3 238.6,30.2 238.6,61.3C238.6,92.4 219.2,112.3 189.1,112.3L154.7,112.3L154.7,10.3ZM188.4,96.8C209.8,96.8 221.3,83 221.3,61.3C221.3,39.6 209.9,25.6 188.4,25.6L172,25.6L172,96.8L188.4,96.8Z",
    style: {
      fill: "rgb(43,50,60)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M289,111.8L289,107.7C286.5,110.2 279,113.2 270.7,113.2C255.6,113.2 243.1,104.2 243.1,89.1C243.1,75.2 255.5,65.4 271.8,65.4C278.4,65.4 285.9,67.7 288.9,69.9L288.9,63.9C288.9,56.4 284.3,50.6 274.8,50.6C268.2,50.6 264,53.4 262.2,58.6L246.3,58.6C248.5,46 260.1,36.5 275.2,36.5C293.8,36.5 304.8,46.8 304.8,63.6L304.8,111.9L289,111.8ZM289,86C287.2,81.4 280.5,78.5 273.9,78.5C266.4,78.5 258.6,81.6 258.6,89C258.6,96.4 266.4,99.6 273.9,99.6C280.5,99.6 287.2,96.8 289,92.1L289,86Z",
    style: {
      fill: "rgb(43,50,60)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M321.2,51.8L309.6,51.8L309.6,38L321.2,38L321.2,18.2L337.8,18.2L337.8,38L354.4,38L354.4,51.8L337.8,51.8L337.8,90C337.8,96 341.1,98.6 346.6,98.6C349.9,98.6 353.7,97.3 356.1,95.6L356.1,110.7C353.3,112.4 348.8,113.4 343.7,113.4C330.6,113.4 321.3,106.4 321.3,91.8L321.2,51.8Z",
    style: {
      fill: "rgb(43,50,60)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M408,111.8L408,107.7C405.5,110.2 398,113.2 389.7,113.2C374.6,113.2 362.1,104.2 362.1,89.1C362.1,75.2 374.5,65.4 390.8,65.4C397.4,65.4 404.9,67.7 407.9,69.9L407.9,63.9C407.9,56.4 403.2,50.6 393.8,50.6C387.2,50.6 383,53.4 381.2,58.6L365.3,58.6C367.5,46 379.1,36.5 394.2,36.5C412.8,36.5 423.8,46.8 423.8,63.6L423.8,111.9L408,111.8ZM408,86C406.2,81.4 399.5,78.5 392.9,78.5C385.4,78.5 377.6,81.6 377.6,89C377.6,96.4 385.4,99.6 392.9,99.6C399.5,99.6 406.2,96.8 408,92.1L408,86Z",
    style: {
      fill: "rgb(43,50,60)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M478.9,113.3C453,113.3 433.9,92.1 433.9,60.8C433.9,29.5 453,8.3 478.9,8.3C504.8,8.3 524,29.5 524,60.8C524,92.1 504.9,113.3 478.9,113.3ZM478.9,16.3C457.3,16.3 442.5,34.6 442.5,60.8C442.5,87 457.3,105.3 478.9,105.3C500.5,105.3 515.4,87 515.4,60.8C515.4,34.6 500.6,16.3 478.9,16.3Z",
    style: {
      fill: "rgb(43,50,60)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M537.6,86.9C541.7,99.2 552.5,105.7 566.5,105.7C580.5,105.7 591.9,98.2 591.9,85.3C591.9,76.3 587.3,70 574.3,66.4L554.9,60.9C540.6,56.9 531.5,50.4 531.5,36C531.5,18.7 546.1,8.4 563.7,8.4C583.6,8.4 595.6,18.9 599.6,34L591.1,34C587.3,23.2 578.5,16.1 563.7,16.1C550.4,16.1 539.6,23.1 539.6,35.5C539.6,46.3 546.6,50.1 559,53.6L576.1,58.6C592.9,63.3 600.2,71.6 600.2,85C600.2,102.9 585.6,113.4 566.5,113.4C547.4,113.4 532.8,103.9 528.8,87L537.6,86.9Z",
    style: {
      fill: "rgb(43,50,60)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(3.41658,0,0,3.37163,-1451.54,-57.0096)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M610.4,34.6C606.3,34.6 602.9,31.4 602.9,27C602.9,22.6 606.3,19.4 610.4,19.4C614.5,19.4 617.9,22.6 617.9,27C617.9,31.4 614.5,34.6 610.4,34.6ZM610.4,20.6C606.9,20.6 604,23.3 604,27C604,30.7 606.9,33.5 610.4,33.5C613.9,33.5 616.8,30.8 616.8,27C616.8,23.2 613.9,20.6 610.4,20.6ZM609,27.8L609,30.9L607.6,30.9L607.6,22.9L610.8,22.9C612.5,22.9 613.6,23.8 613.6,25.4C613.6,26.7 612.8,27.5 611.7,27.8L613.9,30.9L612.3,30.9L610.2,27.8L609,27.8ZM610.9,24.2L609,24.2L609,26.6L610.9,26.6C611.8,26.6 612.3,26.1 612.3,25.4C612.3,24.7 611.8,24.2 610.9,24.2Z",
    style: {
      fill: "rgb(43,50,60)",
      fillRule: "nonzero"
    }
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.957225,0,0,0.957225,2.71619,0.440579)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M63.5,57.4C63.5,31.4 84.6,10.3 110.6,10.3L110.6,57.4L63.5,57.4Z",
    style: {
      fill: "rgb(43,50,60)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.957225,0,0,0.957225,0.367862,0.440579)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.6,10.3C34.6,10.3 55.7,31.4 55.7,57.4L8.6,57.4L8.6,10.3Z",
    style: {
      fill: "rgb(43,50,60)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.908978,0,0,0.908978,6.96156,7.1163)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M111.8,88.7C111.8,102.4 100.7,113.5 87,113.5C73.3,113.5 62.2,102.4 62.2,88.7C62.2,75 73.4,63.9 87.1,63.9C100.8,63.9 111.8,75 111.8,88.7",
    style: {
      fill: "rgb(43,50,60)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.957225,0,0,0.957225,0.367862,2.78891)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 8.6,
    y: 65.2,
    width: 47.1,
    height: 47.1,
    style: {
      fill: "rgb(43,50,60)"
    }
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDataOsLogoCommon2);
export default __webpack_public_path__ + "static/media/dataOS-logo-common-2.64fddb35ceb978fb88fbc25ac0c2ec99.svg";
export { ForwardRef as ReactComponent };